module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAnUlEQVQ4y+2UsQrCQBAF5yKohaAI1903XqO1nZ0psuIfXncIigjGELSJkCpZyYEImeax8Jhm2QUFVsLOSrhZCbmmb5TSM7AGamARvXt09TONFJi0ctZX1kq/YpSmx1gJe2ALTAe6KuAYvdsYK6FMIPzwBOYZcGiGoVTAKXr30l7UBVg24yp6d+3q/8/2R+nvpHUry1TSArgD0vf1Ad78FChd2tKckgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addpic.png
// module id = nrMU
// module chunks = 1